/// <amd-module name="Dashboards/Directory/components/DashboardDirectoryContentView" />
import * as Resources from "Dashboards/Directory/Resources";
import { IColumn } from "OfficeFabric/DetailsList"; // Legacy code - will be removed once new Dashboard directory is moved to GA
import * as React from "react"; // Needed for the connect() call
import { connect } from "react-redux";
import { IProjectData } from "Tfs/Platform/Page";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";
import { currentProject } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataSelectors";
import { DEFAULT_NAME_COLUMN, DirectoryColumnKeys as CommonDirectoryColumnKeys, IDirectoryRow } from "VSS/Features/Directory/DirectoryGrid";
import { ContributedMenuItemProvider } from "VSS/Features/Frame/ContributedMenuItemProvider";
import { ConnectedDirectoryContentView } from "VSS/Features/ReduxDirectory/ConnectedDirectoryContentView";
import { ConnectedDirectoryFilterBar } from "VSS/Features/ReduxDirectory/ConnectedDirectoryFilterBar";
import { isFeatureEnabled } from "VSS/Platform/Feature";
import { VssComponent } from "VSS/Platform/Layout";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { IFilter } from "VSSUI/Utilities/Filter";
import { IHubViewState } from "VSSUI/Utilities/HubViewState"; // Legacy code - will be removed once new Dashboard directory is moved to GA
import { IVssContextualMenuItem, IVssContextualMenuItemProvider } from "VSSUI/VssContextualMenu"; // Legacy code - will be removed once new Dashboard directory is moved to GA
import * as DashboardsDirectoryConstants from "../DashboardsDirectoryConstants";
import { ColumnKeys as DashboardsDirectoryColumnKeys, DescriptionColumn, OwnerColumn, TeamColumn, DashboardTypeColumn, ModifiedByColumn, LastAccessedDateColumn } from "../DashboardsDirectoryConstants";
import { Dashboard, IDashboardsDirectoryArtifact, IDashboardsDirectoryAwareState, Owner } from "../DashboardsDirectoryContracts";
import { DashboardsDirectoryActions } from "../redux/DashboardsDirectoryActions";
import {
    getCanCreateDashboardsPermission,
    getCanDeleteDashboardsPermission,
    getCanManageDashboardSecurityPermission,
    getCanUseTeamButtonPermission
} from "../redux/DashboardsDirectorySelectors";
import { ConnectedFavoriteNameCell } from "./FavoriteNameCell";
import { ConnectedTeamCell } from "./TeamCell";
import { OwnerCell } from "./OwnerCell";
import { DashboardScope } from "Dashboards/Common/Contracts/Dashboard";
import { ago, AgoFormat } from "VSSUI/Utilities/Date";
import { IVssIdentityService } from "VSS/Platform/Identity";
import { IVssPageContext } from "VSS/Platform/Context";
import { getTFSPageData } from "Tfs/Platform/Page";
import { ProjectVisibility } from "Tfs/Platform/Contracts/Core";
import { getFavoritesViewPermission, isFilterVisible } from "VSS/Features/ReduxDirectory/Redux/DirectorySelectors";
import { FavoriteActions } from "VSS/Features/ReduxDirectory/Redux/Favorites/FavoriteActions";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { NewDashboardsDirectoryContentView } from "./DashboardDirectory";
import { DirectoryActions } from "VSS/Features/ReduxDirectory/Redux/DirectoryActions";
import { TTIMonitorActions } from "VSS/Redux/Modules/TTIMonitor";

export interface IDashboardsDirectoryContentViewProps extends IDashboardsDirectoryContentViewOwnProps, IDashboardsDirectoryContentViewMappedProps { }

export interface IDashboardsDirectoryContentViewOwnProps {
    hubViewState: IHubViewState;
    pageContext: IVssPageContext;
}

export interface IDashboardsDirectoryContentViewMappedProps {
    enableContextMenu: boolean;
    enableAddDashboardButton: boolean;
    enableManageDashboardSecurityButton: boolean;
    enableDeleteDashboardButton: boolean;
    allDashboardData: Dashboard[];
    allOwner: Owner[];
    project: IProjectData | undefined;
    enableTeamButton : boolean,
    isFilterVisible : boolean,
    canUseFavorites : boolean
}

/**
 * Renders the visual content of the dashboard directory
 */
export class DashboardsDirectoryContentView extends VssComponent<IDashboardsDirectoryContentViewProps & typeof Actions> {
    public static readonly teamScopedGroupId = "00000000-0000-0000-0000-000000000000";

    // feature flag for new dashboard Directory (NWP)
    private static readonly newDashboardDirectoryFeatureFlag = "WebAccess.Dashboards.NWPEnabled";
    
    public render(): JSX.Element {
        if(isFeatureFlagEnabled(this.props.pageContext, DashboardsDirectoryContentView.newDashboardDirectoryFeatureFlag, false)){
            return(
                <NewDashboardsDirectoryContentView 
                    pageContext={this.props.pageContext}
                    allDashboardData={this.props.allDashboardData}
                    allOwner={this.props.allOwner}
                    project={this.props.project}
                    _onDeleteDashboardClickRow={this._onDeleteDashboardClickRow}
                    enableDeleteDashboardButton={this.props.enableDeleteDashboardButton}
                    enableManageDashboardSecurityButton={this.props.enableManageDashboardSecurityButton}
                    commandBarItems={[this._getNewDashboardButton()]}
                    artifactName={Resources.ArtifactName}
                    artifactIcon={{ iconName: "ViewDashboard" }}
                    enableTeamButton={this.props.enableTeamButton}
                    toggleFilter={this.props.toggleFilter}
                    isFilterVisible={this.props.isFilterVisible}
                    canUseFavorites={this.props.canUseFavorites}
                    onFavoriteToggled={this.props.onFavoriteToggled}
                    ttiScenarioProps={{
                        featureName: DashboardsDirectoryConstants.FeatureName,
                        scenarioName: DashboardsDirectoryConstants.ScenarioNameNewDashboardDirectory
                    }}
                    markTti={this.props.markTti}
            />
            );
        }
        else{
            return (
                <ConnectedDirectoryContentView
                    artifactName={Resources.ArtifactName}
                    artifactIcon={{ iconName: "ViewDashboard" }}
                    hubViewState={this.props.hubViewState}
                    customColumns={this.getColumns()}
                    getContextMenuItems={this.props.enableContextMenu ? this._getContextMenuItems : undefined}
                    getContextMenuItemProviders={this._getContextMenuItemProviders}
                    commandBarItems={[this._getNewDashboardButton()]}
                    onRenderCell={this.onRenderCell}
                    onRenderFilterBar={this._renderFilterBar}
                    ttiScenarioProps={{
                        featureName: DashboardsDirectoryConstants.FeatureName,
                        scenarioName: DashboardsDirectoryConstants.ScenarioName
                    }}
                    additionalKeywordFilterableMembers={["description", "ownerName","modifiedBy"]}
                    additionalSortedMembers={["ownerName"]}
                />
            );
        }
        
    }

    // Legacy code - will be removed once new Dashboard directory is moved to GA
    /** Returns a list of columns to be displayed on the directory view */
    private getColumns(): IColumn[] {
        let columns: IColumn[] = [DEFAULT_NAME_COLUMN];
        if (this.isProjectDashboardsEnabled()) {
            columns.push(OwnerColumn);
        } else {
            columns.push(TeamColumn);
        }
        const tfsPageData = getTFSPageData(this.context.pageContext);
        
        columns.push(DescriptionColumn);
        
        // In case of public projects we will not update last accessed column. We will not display them on UI as well.
        if (tfsPageData && tfsPageData.project
            && tfsPageData.project.visibility !== ProjectVisibility.Public) {
                columns.push(LastAccessedDateColumn);
        }

        columns.push(ModifiedByColumn);
        if(this.isProjectDashboardsEnabled()){
            columns.push(DashboardTypeColumn)
        }
        return columns;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private onRenderCell = (row: IDirectoryRow<IDashboardsDirectoryArtifact>, index: number, column: IColumn, defaultRenderer: any): JSX.Element => {
        switch (column.fieldName) {
            case CommonDirectoryColumnKeys.Name:
                return this._renderNameCell(row);
            case DashboardsDirectoryColumnKeys.DashboardType:
                return this._renderDashboardTypeCell(row);
            case DashboardsDirectoryColumnKeys.Owner:
                return this._renderOwnerCell(row);
            case DashboardsDirectoryColumnKeys.Team:
                return this._renderTeamCell(row);
            case DashboardsDirectoryColumnKeys.Description:
                return this._renderDescriptionCell(row);
            case DashboardsDirectoryColumnKeys.LastAccessedDate:
                return this._renderLastAccessedCell(row);
            case DashboardsDirectoryColumnKeys.ModifiedBy:
                return this._renderModifiedByCell(row);
            default:
                return typeof defaultRenderer === "function" && defaultRenderer(row, index, column);
        }
    };

    private _getNewDashboardButton = (): IHeaderCommandBarItem => {
        return {
            id: "new-dashboard",
            text: Resources.NewDashboard,
            ariaLabel: Resources.NewDashboard,
            isPrimary: true,
            iconProps: {
                iconName: "Add"
            },
            onActivate: this._onNewDashboardClick,
            disabled: !this.props.enableAddDashboardButton
        };
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _getContextMenuItems = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): IVssContextualMenuItem[] => {
        return [
            {
                key: "dashboard-permissions",
                name: Resources.ManageDashboardSecurityMenuItem,
                title: Resources.ManageDashboardSecurityMenuItem,
                iconProps: { iconName: "ShieldSolid" },
                onClick: () => this._onManageSecurityClick(row),
                disabled: !this.props.enableManageDashboardSecurityButton,
                rank: 100,
                groupKey: "general"
            },
            {
                key: "dashboard-delete",
                name: Resources.DeleteDashboardMenuItem,
                title: Resources.DeleteDashboardMenuItem,
                iconProps: { iconName: "Cancel" },
                onClick: () => this._onDeleteDashboardClick(row),
                disabled: !this.props.enableDeleteDashboardButton,
                rank: 200,
                groupKey: "general"
            }
        ];
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _getContextMenuItemProviders = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): IVssContextualMenuItemProvider[] => {
        return [
            new ContributedMenuItemProvider(this.context.pageContext, "ms.vss-dashboards-web.dashboards-directory-dashboard-context-menu", {
                dashboard: {
                    id: row.data.id,
                    name: row.data.name,
                    ownerId: this._getOwnerId(row)
                }
            })
        ];
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _onNewDashboardClick = (): void => {
        this.props.openNewDashboardDialog();
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _onManageSecurityClick = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): void => {
        this.props.openDashboardSecurityDialog(row.data.id, row.data.name, this._getOwnerIdForPermissions(row));
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _onDeleteDashboardClick = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): void => {
        this.props.openDeleteDashboardDialog(row.data.id, this._getOwnerIdForDelete(row), this.props.project!.id);
    };

    // for New Dashboard Directory
    private _onDeleteDashboardClickRow = (row: Dashboard): void => {
        this.props.openDeleteDashboardDialog(row.id, this._getOwnerIdForDeleteOnRow(row), this.props.project!.id);
    };


    // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderDashboardTypeCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        let dashboardType = "";
        switch (row.data.dashboardScope) {
            case DashboardScope.Project_Team:
                dashboardType = Resources.TeamScope;
                break;
            case DashboardScope.Project:
                dashboardType = Resources.ProjectScope;
                break;
        }

        return <div>{dashboardType}</div>;
    }

    // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderNameCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        return <ConnectedFavoriteNameCell row={row} />;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderTeamCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        return <ConnectedTeamCell row={row} />;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderOwnerCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        switch (row.data.dashboardScope) {
            case DashboardScope.Project: return <OwnerCell row={row} isOwner={true} dateString={undefined} />;
            case DashboardScope.Project_Team: return this._renderTeamCell(row);
            default: return <div />;
        }
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderDescriptionCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        return <div>{row.data.description}</div>;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderLastAccessedCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        return <div>{row.data.lastAccessedDate && new Date(row.data.lastAccessedDate) > new Date('0001-01-01T00:00:00Z') &&
            <>
                <span>{(new Date(row.data.lastAccessedDate).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) ? Resources.TodayTextLabel : ago(new Date(row.data.lastAccessedDate), AgoFormat.Compact)}</span>
            </>
        }</div>;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderModifiedByCell(row: IDirectoryRow<IDashboardsDirectoryArtifact>): JSX.Element {
        const userDetails = this.props.pageContext.getService<IVssIdentityService>("IVssIdentityService").getIdentityDetails(row.data.modifiedBy);
        if(userDetails){
            row.data.modifiedByImageUrl = userDetails.imageUrl;
            row.data.modifiedByName = userDetails.displayName;
            let dateString = (row.data.modifiedDate && new Date(row.data.modifiedDate) > new Date('0001-01-01T00:00:00Z')) ? (new Date(row.data.modifiedDate).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) ? Resources.TodayTextLabel : ago(new Date(row.data.modifiedDate), AgoFormat.Compact) : '';
            return <span><OwnerCell row={row} isOwner={false} dateString={dateString} /></span>;
        }
        return <></>;
    }

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _renderFilterBar = (filter: IFilter): JSX.Element => {
        return (
            <ConnectedDirectoryFilterBar
                filter={filter}
                ownerFilterPlaceholderText={
                    this.isProjectDashboardsEnabled() ? Resources.OwnerFilterPlaceholder : Resources.TeamFilterPlaceholder
                }
            />
        );
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _getOwnerId = (row: IDirectoryRow): string => {
        return row.data.owners.length > 0 ? row.data.owners[0].id : "";
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _getOwnerIdForPermissions = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): string => {
        if (row.data.dashboardScope === DashboardScope.Project_Team && row.data.owners) {
            return row.data.owners[0].id;
        }

        return DashboardsDirectoryContentView.teamScopedGroupId;
    };

     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private _getOwnerIdForDelete = (row: IDirectoryRow<IDashboardsDirectoryArtifact>): string | undefined => {
        if (row.data.dashboardScope === DashboardScope.Project_Team && row.data.owners) {
            return row.data.owners[0].id;
        }

        return undefined;
    };

    // for NWP Table
    private _getOwnerIdForDeleteOnRow = (row: Dashboard): string | undefined => {
        if (row.dashboardScope === DashboardScope.Project_Team && row.ownerId) {
            return row.ownerId;
        }

        return undefined;
    };


     // Legacy code - will be removed once new Dashboard directory is moved to GA
    private isProjectDashboardsEnabled() {
        return isFeatureEnabled(this.context.pageContext, "ms.vss-dashboards.team-agnostic-dashboards-feature", false);
    }
}

const Actions = {
    openNewDashboardDialog: DashboardsDirectoryActions.openNewDashboardDialog,
    openDashboardSecurityDialog: DashboardsDirectoryActions.openDashboardSecurityDialog,
    openDeleteDashboardDialog: DashboardsDirectoryActions.openDeleteDashboardDialog,
    toggleFilter: DirectoryActions.toggleFilter,
    onFavoriteToggled: FavoriteActions.toggleFavorite,
    markTti: TTIMonitorActions.markTTI,
};

function mapStateToProps(
    state: IDashboardsDirectoryAwareState & ITfsPageDataAwareState,
    ownProps: IDashboardsDirectoryContentViewOwnProps
): IDashboardsDirectoryContentViewMappedProps {
    return {
        enableContextMenu:
            getCanManageDashboardSecurityPermission(state) || getCanDeleteDashboardsPermission(state),
        enableAddDashboardButton: getCanCreateDashboardsPermission(state),
        enableManageDashboardSecurityButton: getCanManageDashboardSecurityPermission(state),
        enableDeleteDashboardButton: getCanDeleteDashboardsPermission(state),
        project: currentProject(state),
        allDashboardData: state.dashboardsDirectoryState.directoryArtifactState.allDashboards,
        allOwner: state.dashboardsDirectoryState.directoryArtifactState.allOwners,
        enableTeamButton : getCanUseTeamButtonPermission(state),
        isFilterVisible: isFilterVisible(state),
        canUseFavorites: getFavoritesViewPermission(state)
    };
}

export const ConnectedDashboardsDirectoryContentView = connect(
    mapStateToProps,
    Actions
)(DashboardsDirectoryContentView);